import { Agent } from "src/agents/types";
import { useCapabilities } from "src/hooks/useCapabilities";

export const useIsPrebuiltReadOnly = (agent: Agent | undefined): boolean => {
  const { prebuiltAgents } = useCapabilities();
  return (
    !!agent && agent.prebuilt_configuration != null && !prebuiltAgents.canWrite
  );
};
